// @ts-nocheck
import siteLabel from "includes/siteLabel";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import useAccount from "classes/Accounts/hooks/useAccount";
import { QuerySelect } from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import { QueryTagsList } from "components/Tags/TagsList/TagsList";
import genRequest from "includes/request";
import { t } from "i18next";
import "./FiltersDrawer.css";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import { useQuery } from "react-query";
import { FilterFavSites } from "./favSitesFilter.component";
import { useAccountContext } from "providers/AccountProvider";

export default function FiltersDrawer(props) {
	const { accountObj, userOrAdmin } = useAccountContext();
	const account = accountObj.account;
	const { isAdmin } = useAccount();
	const [favSites, setFavSites] = useState([]);
	const [favSiteVisible, setFavSiteVisible] = useState(false);
	let catsQueryFn = null;
	let catsQueryKey = null;

	const cont_ref = useRef();

	const { data, error, isLoading } = useQuery(["FavoritesSites"], () =>
		genRequest(`me/favorite-sites`)
	);

	useEffect(() => {
		if (userOrAdmin) {
			setFavSiteVisible(userOrAdmin === "admin");
		}
		return () => {
			setFavSiteVisible(false);
		}
	}, [userOrAdmin]);

	useOutsideAlerter(cont_ref, handleClose);

	const getCategoriesReq = () => {
		const listCatTypesWhenWeWantTags = [
			"post-contactTypeId"
		];
		let catType = props.catsType;
		if (props.isMobile) {
			catsQueryFn = () =>
				genRequest("groups/company/" + account.companyId)
			catsQueryKey = ["Groups", `Company-${props.catsType}`, account.companyId];
			catType = props.catsType;
		} else {
			catsQueryFn = props.catsQueryFn;
			catsQueryKey = props.catsQueryKey;
		}
		if (props.catsType !== undefined && !listCatTypesWhenWeWantTags.includes(props.catsType)) {
			return {
				queryKey: [
					"Categories",
					"CompanyTyped",
					account.companyId,
					props.catsType,
				],
				queryFn: async () => {
					const result = await genRequest(
						"categories/company/" +
						account.companyId +
						"/type/" +
						catType
					);
					return result;
				},
			};
		}

		return {
			queryKey: catsQueryKey
				? catsQueryKey
				: ["Categories", "Company", account.companyId],
			queryFn: catsQueryFn
				? catsQueryFn
				: () => genRequest("categories/company/" + account.companyId),
		};
	};

	// useQuery

	useEffect(() => {
		if (!isLoading) {
			setFavSites(data);
		}
		return () => {
			setFavSites([]);
		}
	}, [data]);

	//Me/GetFavoritesSites

	const anim = {
		hidden: {
			height: "0px",
			padding: "0px",
			overflow: "hidden",
			transition: {
				ease: "easeOut",
				duration: 0.2,
			},
		},
		show: {
			height: "auto",
			padding: "15px",
			opacity: 1,
			transition: {
				ease: "easeOut",
				duration: 0.2,
			},
		},
	};

	function handleClose(e) {
		if (typeof e.target.className === "string" && e.target?.className.indexOf("filter-button") > -1) return false;
		if (props.onClose) props.onClose();
	}

	if (props.isOpen === false) return false;

	return (
		// <motion.div
		// 	variants={props.anim ? props.anim : anim}
		// 	initial="hidden"
		// 	animate={props.isOpen ? "show" : "hidden"}
		// 	className={`FiltersDrawer d-flex flex-column gap-3${props.isOpen ? " open" : ""
		// 		}${props.className ? " " + props.className : ""}`}
		// 	ref={cont_ref}
		// >
		<div className="FiltersDrawer d-flex flex-column gap-3">
			<h3>{t("Commons.FILTERS")}</h3>
			{props.isMobile ? (
				props.siteSelector && (
					<>
						<div className="sites-drop-cont">
							<QuerySelect
								title={t("Sites.SITES")}
								className="light-bg"
								value={props.curSite}
								onChange={props.siteSelect}
								closeMenuOnSelect={true}
								placeholder={t("Commons.ALL_SITES")}
								all={{
									label: t("Commons.ALL_SITES"),
									value: 0,
								}}
								queryKey={["Sites"]}
								queryFn={() =>
									genRequest(
										"sites/company/" + account.companyId
									)
								}
								treat={(item) => ({
									value: item.id,
									label: siteLabel(item),
								})}
								initialValue={props.curSite}
							/>
						</div>
						{favSites.length > 0 &&
							favSiteVisible &&
							isAdmin() &&
							!props.hideFavSites && (
								<FilterFavSites
									data={favSites}
									favSitesSelected={props.favSites}
									curSite={props.curSite}
									setCurSite={props.siteSelect}
									favSitesSelect={props.favSitesSelect}
								/>
							)}
					</>)
			) : (
				props.siteSelect !== false && (
					<>
						<div className="sites-drop-cont">
							<QuerySelect
								title={t("Sites.SITES")}
								className="light-bg"
								value={props.curSite}
								onChange={props.siteSelect}
								closeMenuOnSelect={true}
								placeholder={t("Commons.ALL_SITES")}
								all={{
									label: t("Commons.ALL_SITES"),
									value: 0,
								}}
								queryKey={["Sites"]}
								queryFn={() =>
									genRequest(
										"sites/company/" + account.companyId
									)
								}
								treat={(item) => ({
									value: item.id,
									label: siteLabel(item),
								})}
								initialValue={props.curSite}
							/>
						</div>
						{favSites.length > 0 &&
							favSiteVisible &&
							isAdmin() &&
							!props.hideFavSites && (
								<FilterFavSites
									data={favSites}
									favSitesSelected={props.favSites}
									curSite={props.curSite}
									setCurSite={props.siteSelect}
									favSitesSelect={props.favSitesSelect}
								/>
							)}
					</>
				)
			)}

			{props.categories !== false && (
				<div>
					<QueryTagsList
						title={t("Commons.CATEGORIES")}
						reset={props.resetCatsFilter}
						className="categories-list"
						{...getCategoriesReq()}
						treat={props.catsTreat ? props.catsTreat : false}
						onItemClick={props.selectCategory}
						selected={props.dispCats}
						color={props.catsColor}
					// unstyled={true}
					/>
				</div>
			)}
			<FilterChilds items={props.filterChilds} />
			{/* </motion.div> */}
		</div>
	);
}

const FilterChilds = ({ items }) => {
	if (!items?.length) return false;

	let dom = items.map((a, key) => {
		if (a.enabled === false) return false;
		return <Child key={key} {...a} />;
	});
	return <div className="d-flex gap-4 flex-column">{dom}</div>;
};

const Child = (child_props) => {
	const { component, title, props } = child_props;

	if (!component) return false;
	return (
		<div>
			{title?.length > 0 && <div className="title">{title}</div>}
			<div>
				<child_props.component {...props} />
			</div>
		</div>
	);
};
